import BedSection from './BedSection/BedSection';
import BeddingSection from './BeddingSection';
import Swiper from '~/ui/components/common/Swiper/Swiper';
import { sleepWellImages } from '../../../../assets/mocks/swiperImages';
import { useTranslation } from 'next-i18next';

const SleepWellSection = () => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$sleepWell' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$sleepWell' });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
  const translatedSleepWellImages = sleepWellImages.map(image => ({
    ...image,
    title: t(`${image.url_key}Title`),
    alt: `${tButton('shopNow')}: ${t(`${image.url_key}Alt`)}`,
    url_key: tLink(image.url_key),
  }));
  return (
    <>
      <BedSection />
      <BeddingSection />
      <div className="bedding-grey-bg">
        <Swiper slides={translatedSleepWellImages} />
      </div>
    </>
  );
};

export default SleepWellSection;
